import { chain } from "lodash";
import toNumber from "lodash/toNumber";

export function parseAgeGroup(ageGroup) {
  const lowerLimit = ageGroup.lower_limit;
  const upperLimit = ageGroup.upper_limit;

  if (upperLimit) {
    return `${lowerLimit}-${upperLimit}`;
  }

  return `${lowerLimit}+`;
}

export function getLowestAgeGroup(ageGroups) {
  if (!ageGroups || ageGroups.length === 0) {
    return null;
  }
  return [...ageGroups].sort((a, b) => {
    const aLower = a && a.lower_limit != null ? a.lower_limit : Infinity;
    const bLower = b && b.lower_limit != null ? b.lower_limit : Infinity;
    if (aLower !== bLower) {
      return aLower - bLower;
    }
    const aUpper = a && a.upper_limit != null ? a.upper_limit : Infinity;
    const bUpper = b && b.upper_limit != null ? b.upper_limit : Infinity;
    return aUpper - bUpper;
  })[0];
}

export function parseAgeGroups(ageGroups) {
  return ageGroups.map(parseAgeGroup).join(", ");
}

export const formatAgeGroups = value => {
  const valueSplitIntoArrayOfArrays = chain(value)
    .replace(/\s/g, "")
    .replace("+", "-999999")
    .split(",")
    .map(group => group.split("-"))
    .value();

  return valueSplitIntoArrayOfArrays.map(ageGroupAsArrayOfStrings => {
    return ageGroupAsArrayOfStrings.map(eachValue => toNumber(eachValue));
  });
};
